import { Metric } from "src/api/graphql/graphql.ts"
import { RowCondition } from "src/pages/DataAssets/views/Expectations/Expectation/CreateExpectationDrawer/types.ts"
import {
  ColumnType,
  getColumnTypeFromColumnDataType,
  COLUMN_TYPE_HELPERS,
} from "src/pages/DataAssets/views/Expectations/Expectation/uiForms/customRenderers/columnType"

export const ROW_CONDITION_STRING_OPERATORS = ["!=", "<", "<=", "==", ">", ">=", ".notNull()"] as const
export type RowConditionStringOperator = (typeof ROW_CONDITION_STRING_OPERATORS)[number]

type Options = { value: string; label: string }

export function useColumnTypeOperators(
  data: Partial<RowCondition> | undefined,
  metrics: Metric[] | null,
  serverOperators: string[],
): {
  options: Options[]
  columnType: ColumnType
} {
  const name = data?.["column"]
  const metric = metrics?.find((metric) => metric.columnName === name)
  const type = getColumnTypeFromColumnDataType(metric?.columnDataType ?? "")
  const { operators } = COLUMN_TYPE_HELPERS[type]
  const options = serverOperators
    .filter((operator) => (operators as string[]).includes(operator))
    .map((value) => ({ value, label: value }))
  return { options, columnType: type }
}
